// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class header {
	constructor () {
		this.$mobileMenuButton  = $('.mobile-menu-button')
		this.$mobileNavPanel    = $('.mobile-nav-panel')
		this.$mobileCloseButton = $('.mobile-close-button')

		this.$mobileMenuButton.click((event) => {
			this.showMobileNavPanel()
		})

		this.$mobileCloseButton.click((event) => {
			this.hideMobileNavPanel()
		})
	}

	showMobileNavPanel () {
		this.$mobileNavPanel.addClass('show')
	}

	hideMobileNavPanel () {
		this.$mobileNavPanel.removeClass('show')
	}
}

export default header


// WEBPACK FOOTER //
// ./src/js/triboro/header/header.js